<rt-button
  #insertDropdownTrigger="rtOverlayOrigin"
  (click)="openDropdown($event, insertDropdown)"
  (mousedown)="saveSelection($event)"
  variant="outlined"
  [class.active]="insertDropdown.open"
  rt-overlay-origin
  class="insert-button"
>
  <rt-icon name="playlist-add"></rt-icon>
  <span>{{ 'app.redactor_inserts.dropdown.heading' | translate }}</span>
</rt-button>

<ng-template
  #insertDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="insertDropdownTrigger"
  [rtConnectedOverlayPosition]="['bottomright']"
  (backdropClick)="insertDropdown.open = false"
>
  <rt-redactor-inserts-dropdown
    [emailTemplateInsideTemplate]="emailTemplateInsideTemplate"
    [inserts]="filteredInserts!"
    [dropdownRef]="insertDropdown"
    [canManageCandidates]="canManageCandidates"
    (insertLink)="insertLink($event)"
    (emailTemplateChoose)="emailTemplateChoose.emit($event)"
    (saveAsTemplate)="saveAsTemplate.emit()"
  >
  </rt-redactor-inserts-dropdown>
</ng-template>
